// src/sectors/pilates/members/modal/detail/hooks/useMemberPackages.js
import React from 'react';
import { membersApi } from 'sectors/pilates/members/api/membersApi';

function normalizeArr(res) {
  if (Array.isArray(res)) return res;
  if (res?.items && Array.isArray(res.items)) return res.items;
  if (res?.content && Array.isArray(res.content)) return res.content;
  return [];
}

// ödeme durumu hesap (alan isimleri farklı olsa bile çalışsın)
function computePayStatus(pkg) {
  const totalCents =
    Number(pkg?.totalCents ?? pkg?.totalAmountCents ?? pkg?.priceCents ?? pkg?.amountCents ?? 0) ||
    0;

  const paidCents = Number(pkg?.paidCents ?? pkg?.paidAmountCents ?? pkg?.paid ?? 0) || 0;

  const debtCents =
    Number(pkg?.debtCents ?? pkg?.remainingCents ?? Math.max(0, totalCents - paidCents)) || 0;

  const explicit = String(pkg?.paymentStatus || '').toUpperCase(); // PAID/UNPAID/PARTIAL

  if (explicit === 'PAID') return { code: 'PAID', totalCents, paidCents, debtCents: 0 };
  if (explicit === 'UNPAID')
    return { code: 'UNPAID', totalCents, paidCents: 0, debtCents: totalCents };
  if (explicit === 'PARTIAL') return { code: 'PARTIAL', totalCents, paidCents, debtCents };

  if (totalCents <= 0) return { code: 'UNKNOWN', totalCents, paidCents, debtCents };
  if (paidCents <= 0) return { code: 'UNPAID', totalCents, paidCents, debtCents: totalCents };
  if (paidCents >= totalCents)
    return { code: 'PAID', totalCents, paidCents: totalCents, debtCents: 0 };
  return { code: 'PARTIAL', totalCents, paidCents, debtCents };
}

export function useMemberPackages(memberId, open) {
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [packages, setPackages] = React.useState([]);

  const fetchPackages = React.useCallback(async () => {
    if (!memberId) return;
    try {
      setErr(null);
      setLoading(true);

      const res = await membersApi.memberPackages(memberId);
      const arr = normalizeArr(res);

      // createdAt desc (varsa)
      arr.sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));

      setPackages(arr);
    } catch (e) {
      console.error('membersApi.memberPackages failed:', e);
      setErr(e?.message || 'Paketler yüklenemedi.');
      setPackages([]);
    } finally {
      setLoading(false);
    }
  }, [memberId]);

  React.useEffect(() => {
    if (open && memberId) fetchPackages();
    if (!open) {
      setErr(null);
      setLoading(false);
      setPackages([]);
    }
  }, [open, memberId, fetchPackages]);

  const enriched = React.useMemo(
    () => packages.map((p) => ({ ...p, _pay: computePayStatus(p) })),
    [packages]
  );

  return { loading, err, packages: enriched, fetchPackages };
}
